exports = module.exports = require("../../../../apps/experimentation-ui/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ane-Detail:not(:last-child) {\n  margin-bottom: 25px;\n}\n.ane-Detail .ane-Detail-label {\n  font-size: 12px;\n  padding: 0;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  color: #666666;\n}\n.ane-Detail .ane-Detail-value {\n  font-size: 14px;\n  word-break: break-all;\n}", ""]);

